import React, { useEffect, useState } from "react";

import { Tooltip } from "@react95/core";
import { useApp } from "../../context/AppContext";

import {
  Inetcpl1314,
  Msnp32WrkgrpIcon,
  Msnsign100,
  MsnsignIcoApp,
  Rnaapp114,
  Rnaapp113,
  Rasapi32100,
  Rasapi32101,
  Rasapi32102,
  Rasapi32103,
  Rnaapp110,
  Rnaapp111,
  Rnaapp112,
  Rasapi32104,
  Rnaapp102,
} from "@react95/icons";

import { NetworkStatusDef } from "../Modal/NetworkStatus";

type StatusInfo = {
  icon: React.ReactNode;
  title: string;
  overlay?: string;
};

// the connected icon will switch between three icons (animated,  400ms each)
function ConnectedIcon() {
  const [frame, setFrame] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setFrame((prev) => (prev + 1) % 4);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  switch (frame) {
    case 0:
      return <Rnaapp110 variant="16x16_4" />;
    case 1:
      return <Rnaapp111 variant="16x16_4" />;
    case 2:
      return <Rnaapp112 variant="16x16_4" />;
    default:
      return <Rnaapp113 variant="16x16_4" />;
  }
}

export default function ConnectionIndicator() {
  const { status, error, openModal } = useApp();

  const getStatusInfo = (): StatusInfo => {
    switch (status) {
      case "ready":
        return {
          title: "Connected!",
          icon: <ConnectedIcon />,
        };
      case "connecting":
        return {
          title: "Connecting to server...",
          icon: <Rnaapp102 variant="16x16_4" />,
        };
      case "authenticating":
        return {
          title: "Authenticating session...",
          icon: <Rnaapp102 variant="16x16_4" />,
        };
      case "idle":
        return {
          title: "Disconnected from server",
          icon: <Rnaapp114 variant="16x16_4" />,
          overlay: "#0000003f",
        };
      case "error":
        return {
          icon: <Rnaapp114 variant="16x16_4" />,
          title: `Error: ${error || "Connection failed"}`,
        };
      default:
        return {
          icon: <Rnaapp114 variant="16x16_4" />,
          title: "Not connected",
        };
    }
  };

  const info = getStatusInfo();

  return (
    <Tooltip text={info.title}>
      <div
        style={{
          width: "20px",
          height: "20px",
          cursor: "default",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        onClick={(e) => {
          openModal(NetworkStatusDef);
        }}
      >
        {info.icon}
      </div>
    </Tooltip>
  );
}
